// extracted by mini-css-extract-plugin
export default {"info_title":"style_info_title__VGL4t","info_text":"style_info_text__DitBz","transfer_text":"style_transfer_text__df6Js"};